import { Injectable } from "@angular/core";

import { Client } from "@stomp/stompjs";
import { BehaviorSubject } from "rxjs";

@Injectable()
export class ChatService {
  private stompClient: Client;
  public eventUpdates$: BehaviorSubject<any> = new BehaviorSubject(null);
  urlString: any;

  constructor() {
    if (window.location.hostname == "localhost") {
      this.urlString = "wss://sandbox.teamium.net";
      //  this.urlString ="ws://localhost:8180/"
    } else {
      this.urlString = `wss://${window.location.hostname}`;
    }
  }

  disconnect() {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.deactivate();
      console.log("WebSocket disconnected");
    }
  }

  connect() {
    this.stompClient = new Client({
      brokerURL: `${this.urlString}/teamiumapp/ws?token=${sessionStorage.getItem("token")}`,
      connectHeaders: {},
      debug: (str) => console.log(str),
      reconnectDelay: 5000,
      heartbeatIncoming: 4000,
      heartbeatOutgoing: 4000,
    });

    this.stompClient.onStompError = (error) => {
      console.error("WebSocket Error:", error);
    };

    this.stompClient.onConnect = () => {
      console.log("Connected to WebSocket");
      this.stompClient.subscribe("/topic/api-refresh", (message) => {
        console.log(JSON.parse(message.body), "Event data");
        this.eventUpdates$.next(JSON.parse(message.body));
      });
    };

    this.stompClient.activate();
  }

  sendEventUpdate(event: any) {
    if (this.stompClient && this.stompClient.connected) {
      this.stompClient.publish({
        destination: "/chat", // This matches the @MessageMapping in Spring Boot
        body: JSON.stringify(event),
      });
    }
  }
}
